import settings from '@/content/settings.json';

/**
 * Configurações de funcionamento do site.
 *
 * Os valores vêm de `src/content/settings.json`, editável pelo painel em
 * /admin. Este módulo só dá tipo e junta as constantes puramente técnicas,
 * que não fazem sentido expor para edição.
 */

export const SITE = settings.site;

export const CONTACT = settings.contact;

export const BUSINESS_HOURS = settings.businessHours;

export const COMMERCE = {
  /**
   * Preços em `src/content/products.json` são valores de referência.
   * Em `false`, a loja inteira entra em modo "consulte o valor": a lista
   * continua funcionando como orçamento e todo preço vira uma chamada.
   */
  showPrices: settings.commerce.showPrices,

  /** Valor (R$) a partir do qual a entrega em São Paulo sai de graça. */
  freeShippingThreshold: settings.commerce.freeShippingThreshold,

  /** Taxa de entrega (R$) abaixo do limite acima. */
  deliveryFee: settings.commerce.deliveryFee,

  /** Teto de unidades do mesmo item por pedido. */
  maxQuantityPerItem: settings.commerce.maxQuantityPerItem,

  /* -- Constantes técnicas: não editáveis pelo painel ------------------- */

  /** Chaves de localStorage. Versionadas para uma mudança de formato não
   *  quebrar a visita de quem já tem dados salvos. */
  cartStorageKey: 'brucepets.cart.v1',
  favoritesStorageKey: 'brucepets.favorites.v1',
} as const;
